module.exports = __webpack_public_path__ + "img/molecule.20f3f767.svg";